import { useEffect } from "react";
import type { OrganizerVisualIdentity } from "../utils/organizerVisualIdentity";
import { organizerIdentityStyle } from "../utils/organizerVisualIdentity";

const ORGANIZER_THEME_ATTRIBUTE = "data-organizer-page-theme";

export default function useOrganizerPageVisualIdentity(
  identity: OrganizerVisualIdentity | null | undefined,
  enabled: boolean,
) {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") return;

    const body = document.body;
    const style = organizerIdentityStyle(identity) as Record<string, string>;
    const previousAttribute = body.getAttribute(ORGANIZER_THEME_ATTRIBUTE);
    const previousValues = new Map<string, string>();

    Object.entries(style).forEach(([property, value]) => {
      previousValues.set(property, body.style.getPropertyValue(property));
      body.style.setProperty(property, value);
    });
    body.setAttribute(ORGANIZER_THEME_ATTRIBUTE, "true");

    return () => {
      previousValues.forEach((value, property) => {
        if (value) body.style.setProperty(property, value);
        else body.style.removeProperty(property);
      });
      if (previousAttribute === null) {
        body.removeAttribute(ORGANIZER_THEME_ATTRIBUTE);
      } else {
        body.setAttribute(ORGANIZER_THEME_ATTRIBUTE, previousAttribute);
      }
    };
  }, [enabled, identity]);
}
